import { StrictMode } from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "settings";
import { SENTRY_ENVIRONMENT } from "settings";
import { store } from "api/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

Sentry.init({
  dsn: "https://2beb267f30de36df4c4d9966b01b9b90@o4506571270062080.ingest.us.sentry.io/4509663232131072",
  sendDefaultPii: true

});
root.render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);

reportWebVitals();
